import { ContractAnnexModel, ContractAnnexModelJson } from '@gi/models/contract-annex-model';

export interface ModelOfferContractAnnexModelJson {
  id: number;
  contract_annex_model: Partial<ContractAnnexModelJson>;
}

export class ModelOfferContractAnnexModel {
  constructor(
    public id?: number,
    public model?: ContractAnnexModel
  ) {}

  static fromJson(json: Partial<ModelOfferContractAnnexModelJson>): ModelOfferContractAnnexModel {
    return new ModelOfferContractAnnexModel(
      json.id,
      json.contract_annex_model ? ContractAnnexModel.fromJson(json.contract_annex_model) : null
    );
  }

  static toJson(model: ModelOfferContractAnnexModel): ModelOfferContractAnnexModelJson {
    return {
      id: model.id,
      contract_annex_model: model.model ? ContractAnnexModel.toJson(model.model) : null
    };
  }
}
